module.exports = __webpack_public_path__ + "img/ss1.d9e8b7f4.png";